
// TODO: find a way of getting the properties from the type!
export function createAppProperties<T extends object>(...appProperties: (keyof T)[]): readonly string[] {
    return appProperties as string[];
}
